module.exports = __webpack_public_path__ + "static/img/web_pg_vo.1f570ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web_pg_vo.jpg
// module id = /IBP
// module chunks = 1